// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__C-fBC","questions":"styles_questions__NG2OF","footer":"styles_footer__2JieP"};